var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 190 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53039 13.5303C5.2375 13.8232 4.76262 13.8232 4.46973 13.5303L0.469732 9.53033C0.176838 9.23744 0.176838 8.76256 0.469732 8.46967C0.762624 8.17678 1.2375 8.17678 1.53039 8.46967L4.25006 11.1893L4.25006 1C4.25006 0.585786 4.58585 0.25 5.00006 0.25C5.41428 0.25 5.75006 0.585786 5.75006 1L5.75006 11.1893L8.46973 8.46967C8.76262 8.17678 9.2375 8.17678 9.53039 8.46967C9.82328 8.76256 9.82328 9.23744 9.53039 9.53033L5.53039 13.5303Z",
    fill: "#28303F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabArrowDown);
export default __webpack_public_path__ + "static/media/TabArrowDown.d5f2d55fa23368839adcaa8f6847c5b4.svg";
export { ForwardRef as ReactComponent };